import React, {
  useState,
  useEffect,
  useRef,
  useCallback,
  useMemo,
} from "react";
import images from "../../../images";
import {
  usePostOndemandMutation,
  useGetListSegmentionQuery,
  usePostCalculatorTokenXPMutation,
} from "../../../services/apiSlice";
import LoadingCommon from "../../../components/common/LoadingStatus/LoadingCommon";
import Header from "../../../components/Header/Header";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import StepObjectives from "../StepOnDemand/StepObjectives";
import DemographicSearch from "./../StepOnDemand/StepWhoAsk";
import StepLocation from "./../StepOnDemand/StepLocation";
import StepPreview from "../StepOnDemand/StepPreview";
import StepWhatsAsk from "../StepOnDemand/StepWhatAsk";
import { toast } from "react-toastify";
import { useSelector, useDispatch } from "react-redux";
import {
  clearAllFormData,
  clearQuestionAIGen,
  clearQuestionCustom,
  setObjectiveNameRedux,
  setObjectiveDefaultIdRedux,
  clearObjective,
  clearQuestionsDataOndemandDefault,
} from "../../../redux/featuresSlice/commonSlice";
import {
  clearAllFormDataSegmentation,
  restorePreviousFilters,
} from "../../../redux/featuresSlice/segmantation";
import CommonModal from "../../../components/common/Modal/ModalCommon";
import Button from "../../../components/common/Button/Button";
import { useTranslation } from "react-i18next";
import { convertToUTC } from "../../../Utils/helper";
import { clearDataAIRedux } from "../../../redux/featuresSlice/objectiveDataAI";
const QuestOndemand = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const location = useLocation();
  const [isDropDownOpen, setIsDropDownOpen] = useState(false);

  const [searchParams] = useSearchParams();
  const stepParam = searchParams.get("step");
  const objectiveIdParam = searchParams.get("objectiveId");
  const objectiveNameParam = searchParams.get("objectiveName");
  const [shopperCount, setShopperCount] = useState(20);
  const [questType, setQuestType] = useState("");
  const {
    questionsDataOndemandCustom,
    questionsDataOndemandDefault,
    questionsDataOndemandAIGen,
    reduxLocations,
    locationList,
    description,
    requirement,
    expiryDate,
    startDate,
    thumbnails,
    questName,
    incentive,
    objectiveNameRedux,
    objectiveIdDefaultRedux,
  } = useSelector((state) => state.common);

  const totalCost = shopperCount * incentive * locationList.length * 2;
  const startDateObj = new Date(startDate);
  const expiryDateObj = new Date(expiryDate);
  const {
    custom_segmentations,
    segmentationDataRedux,
    qualifyingQuestionsData,
  } = useSelector((state) => state.filters);

  const optionOndemandModalRef = useRef(null);
  const confirmBackToObjectiveModalRef = useRef(null);
  const confirmBackToStepLocationModalRef = useRef(null);

  const [postOndemand, { isLoading: isLoadingCreateQuest }] =
    usePostOndemandMutation();
  const { refetch: refetchSegmentations } = useGetListSegmentionQuery({
    limit: 10,
    page: 1,
  });
  const [isBackNavigation, setIsBackNavigation] = useState(false);
  const [state, setState] = useState({
    selectedObjective: objectiveIdParam
      ? {
          id: objectiveIdParam,
          name: objectiveNameParam,
        }
      : null,
    selectedObjectiveActive: "",
    currentStep: stepParam && !isNaN(stepParam) ? parseInt(stepParam, 10) : 1,
    currentTab: "default",
    page: 1,
    limit: 5,
    status: "",
    modalOpenQualificationQuestions: false,
    requirementAI: "",
    descriptionAI: "",
    selectedObjectiveStatus: "",
    idObjectiveDefault: "",
    resetObjectivesKey: Date.now(),
  });

  const [tokenXP, setTokenXP] = useState();
  const totalSteps = 5;
  const displayedTotalSteps = 5;

  // const { isLoading: isLoadingObjectiveData } = useGetListObjectivesQuery({
  //   page: state?.page,
  //   limit: state?.limit,
  //   status: state?.status,
  // });
  const combinedQuestions = useMemo(() => {
    // Helper function to check if a value is empty
    const isEmpty = (value) =>
      value === undefined ||
      value === null ||
      (typeof value === "string" && value.trim() === "");

    const formattedQuestionsDefault = questionsDataOndemandDefault.map((q) => ({
      question: q.objective_question || q.question || q.question_text,
      createdAt: q.createdAt || 0,
      type: q.type || q.question_type,
      is_required: q.required || true,
      is_qualifying_question: false,
      is_additional_comment: q?.isAdditionalComments ? true : false,
      additional_comment_placeholder: q.additionalComments || "",
      is_required_additional_comment: q.compulsory ? true : false,
      compulsory_additional_comments: q.compulsory ? true : false,
      has_other_option: q?.options?.some((opt) => opt.isOther) || false,
      options:
        q.options
          ?.map((opt) => ({
            option_text: opt.option_text ? opt.option_text : opt.text,
            is_correct: opt.is_correct || false,
            value: opt.value || opt.text || q.answer || "",
            is_other_option: opt.isOther || false,
          }))
          .filter((opt) => !isEmpty(opt.option_text) || !isEmpty(opt.value)) ||
        [],
    }));

    const formattedQuestionsAI = questionsDataOndemandAIGen.map((q) => ({
      question: q.objective_question || "" || q.question_text || q.question,
      createdAt: q.createdAt,
      type: q.type || q.question_type,
      is_required: q.required || true,
      is_qualifying_question: false,
      is_additional_comment: q?.isAdditionalComments ? true : false,
      additional_comment_placeholder: q.additionalComments || "",
      is_required_additional_comment: q.compulsory ? true : false,
      compulsory_additional_comments: q.compulsory ? true : false,
      has_other_option: q?.options?.some((opt) => opt.isOther) || false,
      options:
        q.options
          ?.map((opt) => ({
            option_text: opt.option_text ? opt.option_text : opt.text,
            is_correct: opt.is_correct || false,
            value: opt.value || opt.text || q.answer || "",
            is_other_option: opt.isOther || false,
          }))
          .filter((opt) => !isEmpty(opt.option_text) || !isEmpty(opt.value)) ||
        [],
    }));

    const formattedQuestions = questionsDataOndemandCustom.map((q) => ({
      question: q.question || q.question_text || q.objective_question,
      type: q.type || q.question_type,
      createdAt: q.createdAt,
      is_required: q.required || true,
      is_qualifying_question: false,
      is_additional_comment: q?.isAdditionalComments ? true : false,
      additional_comment_placeholder: q.additionalComments || "",
      is_required_additional_comment: q.compulsory ? true : false,
      compulsory_additional_comments: q.compulsory ? true : false,
      has_other_option: q?.options?.some((opt) => opt.isOther) || false,
      options:
        q.options
          ?.map((opt) => ({
            option_text: opt.option_text ? opt.option_text : opt.text,
            is_correct: opt.is_correct || false,
            value: opt.value || opt.text || q.answer || "",
            is_other_option: opt.isOther || false,
          }))
          .filter((opt) => !isEmpty(opt.option_text) || !isEmpty(opt.value)) ||
        [],
    }));

    const allQuestions = [
      ...formattedQuestionsDefault,
      ...formattedQuestionsAI,
      ...formattedQuestions,
    ];

    return allQuestions.sort((a, b) => {
      const createdAtA = a.createdAt || 0;
      const createdAtB = b.createdAt || 0;

      return createdAtA - createdAtB;
    });
  }, [
    questionsDataOndemandDefault,
    questionsDataOndemandCustom,
    questionsDataOndemandAIGen,
  ]);

  const [postCalculatorTokenXP, { isLoading: isLoadingCalculatorTokenXP }] =
    usePostCalculatorTokenXPMutation();

  useEffect(() => {
    if (segmentationDataRedux.length === 0 && state.currentStep === 1) {
      dispatch(restorePreviousFilters());
    }
  }, [dispatch, segmentationDataRedux.length, state.currentStep]);

  const handleOptionOndemand = () => {
    optionOndemandModalRef.current.openModal();
    // setIsDropDownOpen(false);
  };

  const handleDiscard = () => {
    dispatch(clearAllFormData());
    dispatch(clearAllFormDataSegmentation());
    dispatch(clearObjective());
    dispatch(clearDataAIRedux());
    setQuestType("");
    navigate("/");
  };

  const handleConfirmBackToObjective = () => {
    setState((prev) => ({
      ...prev,
      // selectedObjective: { id: null, name: state.selectedObjective?.name },
      currentStep: Math.max(prev.currentStep - 1, 1),
      resetObjectivesKey: Date.now(),
      selectedObjective: null, // Clear all objective data
      selectedObjectiveStatus: null,
    }));
    navigate(location.pathname, { replace: true });

    dispatch(clearQuestionsDataOndemandDefault());
    dispatch(clearQuestionAIGen());
    dispatch(clearQuestionCustom());
    dispatch(clearDataAIRedux());

    confirmBackToObjectiveModalRef.current.closeModal();
  };

  const handleObjectiveSelect = useCallback(
    ({ id, name, status, idObjectiveDefault }) => {
      setState((prev) => ({
        ...prev,
        selectedObjective: {
          id,
          name,
        },
        selectedObjectiveStatus: { status },
        idObjectiveDefault: idObjectiveDefault,
      }));
    },
    []
  );

  const handleNextStep = async () => {
    if (state.currentStep === 1) {
      if (!state.selectedObjective?.id) {
        toast.warning(t("toast.warning.pleaseSelectAnObjective"));
        return;
      } else {
        dispatch(setObjectiveNameRedux(state.selectedObjective.name));
        dispatch(setObjectiveDefaultIdRedux(state.idObjectiveDefault));

        setState((prev) => ({
          ...prev,
          currentStep: prev.currentStep + 1,
        }));
      }
    } else if (state.currentStep === 2) {
      const hasEmptyQuestion = combinedQuestions.some((q) => q.question === "");

      if (hasEmptyQuestion) {
        toast.error(t("toast.error.thereIsAQuestionThatIsBlank"));
        return;
      } else if (combinedQuestions.length < 5) {
        toast.error(t("toast.error.theQuestionsListMustHaveAtLeast5Items"));
        return;
      } else {
        setState((prev) => ({
          ...prev,
          currentStep: Math.min(prev.currentStep + 1, totalSteps),
        }));
      }
    } else if (state.currentStep === 3) {
      if (
        qualifyingQuestionsData.length === 0 &&
        custom_segmentations.length === 0
      ) {
        toast.error(t("toast.error.minimumOf1FilterIsRequired"));
        return;
      }
      let hasCheckedOption = false;
      for (const segment of custom_segmentations) {
        if (segment.options.some((opt) => opt.checked)) {
          hasCheckedOption = true;
          break;
        }
      }

      if (!hasCheckedOption && qualifyingQuestionsData.length === 0) {
        toast.error(t("toast.error.pleaseSelectAtLeastOneOptionInFilters"));
        return;
      } else {
        setState((prev) => ({
          ...prev,
          currentStep: Math.min(prev.currentStep + 1, totalSteps),
        }));
      }
    } else if (state.currentStep === 4) {
      if (reduxLocations?.locationList?.length === 0) {
        toast.error(t("toast.error.pleaseAddLocationInYourProfile"));
        return;
      } else if (locationList.length === 0) {
        toast.error(t("toast.error.pleaseSelectLocation"));
        return;
      } else if (!questType) {
        toast.error(
          t("quest.questType.required") || "Please select a quest type"
        );
        return;
      } else {
        setState((prev) => ({
          ...prev,
          currentStep: Math.min(prev.currentStep + 1, totalSteps),
        }));
      }
      if (expiryDateObj < startDateObj) {
        toast.error(t("toast.error.expiryDateBeforeStartDate"));
        return;
      }
      if (!tokenXP && isLoadingCalculatorTokenXP) {
        toast.warning(t("toast.warning.pleaseWaitCalculatingTokenXP"));
        return;
      }

      if (!tokenXP) {
        try {
          const questionCounts = combinedQuestions;
          const bodyTokenXP = { questions: questionCounts };
          const response = await postCalculatorTokenXP(bodyTokenXP).unwrap();

          if (
            response.message === "List successful" ||
            response.status === 200
          ) {
            if (!response.data || Object.keys(response.data).length === 0) {
              console.warn(t("toast.warning.apiReturnedEmptyData"));
              setTokenXP({ tokens: 0, xp: 0, time_require: 0 });
            } else {
              setTokenXP(response.data);
            }
          } else {
            console.warn("Unexpected response message:", response.message);
            toast.error(
              t("toast.error.unexpectedResponseFromTokenXPCalculation")
            );
            return;
          }
        } catch (error) {
          console.error("Error fetching token XP:", error);
          setTokenXP({ tokens: 0, xp: 0, time_require: 0 });
          toast.error(t("toast.error.failedToCalculateTokenXP"));
          return;
        }
      }
    } else if (state.currentStep === 5) {
      const systemSegmentations = [];
      const customSegmentations = [];
      const qualifyingSegmentations = [];

      custom_segmentations.forEach((segment) => {
        const originalSegment = segmentationDataRedux.find(
          (s) => s.id === segment.id
        );

        const checkedOptions = segment.options
          .filter((opt) => opt.checked)
          .map((opt) => ({
            min_value: opt.min_value || 0,
            max_value: opt.max_value || 0,
            value: opt.value || "",
            title: opt.title || "",
            description: opt.description || "",
          }));

        const hasChanges = segment.options.some((opt) => opt.checked !== true);

        if (hasChanges && segment.consumer_map_field !== "custom") {
          if (checkedOptions.length > 0) {
            customSegmentations.push({
              name: segment.name,
              type: segment.type,
              description: segment.description,
              category: segment.category,
              consumer_map_field: segment.consumer_map_field,
              options: checkedOptions,
            });
          }
        } else if (originalSegment) {
          systemSegmentations.push(segment.id);
        }
      });

      qualifyingQuestionsData.forEach((segment) => {
        const hasCheckedOptions = segment.options.some((opt) => opt.checked);
        if (hasCheckedOptions) {
          qualifyingSegmentations.push({
            name: segment.name,
            type: segment.type || "enum",
            description: segment.description || "",
            category: segment.category || "custom",
            consumer_map_field: null,
            options: segment.options
              .filter((opt) => opt.checked)
              .map((opt) => ({
                min_value: opt.min_value || 0,
                max_value: opt.max_value || 0,
                value: opt.value || "",
                title: opt.title || "",
                description: opt.description || "",
              })),
          });
        }
      });

      const combinedQuestionsSegmentation = [
        ...customSegmentations,
        ...qualifyingSegmentations,
      ];

      const body = {
        objective_text: objectiveNameRedux,
        objective_id: objectiveIdDefaultRedux,
        name:
          questName ||
          objectiveNameParam ||
          state.selectedObjective?.name ||
          objectiveNameRedux,
        description: description || "",
        est_time: tokenXP?.time_require,
        start_time: convertToUTC(startDate) || "",
        expire_time: convertToUTC(expiryDate) || "",
        token: tokenXP.tokens || 0,
        xp: tokenXP.xp || "",
        incentives: tokenXP.incentives || 0,
        requirement: requirement || "",
        max_slot: shopperCount || 20,
        questions: combinedQuestions,
        location_ids: locationList.map((loc) => loc.id) || [],
        thumbnails: thumbnails || [],
        system_segmentations: systemSegmentations,
        custom_segmentations: combinedQuestionsSegmentation,
        total_cost: totalCost,
        quest_type: questType,
      };

      dispatch(restorePreviousFilters());
      try {
        const responseOndemand = await postOndemand(body).unwrap();
        if (
          responseOndemand.message === "Creation successful" ||
          responseOndemand.status === 200
        ) {
          toast.success(t("toast.success.questCreatedSuccessfully"));
          dispatch(clearAllFormData());
          dispatch(clearAllFormDataSegmentation());
          dispatch(clearObjective());
          dispatch(clearDataAIRedux());
          await refetchSegmentations();
          setState({
            selectedObjective: null,
            selectedObjectiveActive: "",
            currentStep: 1, // Reset to step 1
            currentTab: "default",
            page: 1,
            limit: 5,
            status: "",
            modalOpenQualificationQuestions: false,
            requirementAI: "",
            descriptionAI: "",
            selectedObjectiveStatus: "",
          });
          setShopperCount(20);
          setTokenXP(null); // Clear tokenXP
          setQuestType("");
          navigate("/");
        }
      } catch (err) {
        // console.error("Error posting answer:", err);

        if (
          err.data?.detail?.[0]?.msg ===
          "The questions list must have at least 5 items"
        ) {
          toast.error(t("toast.error.theQuestionsListMustHaveAtLeast5Items"));
        } else {
          toast.error(t(err.data?.detail?.[0]?.msg));
        }
      }
    } else {
      setState((prev) => ({
        ...prev,
        currentStep: Math.min(prev.currentStep + 1, totalSteps),
      }));
    }
  };

  // const handlePrevStep = () => {
  //   if (state.currentStep === 2) {
  //     confirmBackToObjectiveModalRef.current.openModal();
  //   } else   if (state.currentStep === 3) {

  //   }  else {
  //     setState((prev) => ({
  //       ...prev,
  //       currentStep: Math.max(prev.currentStep - 1, 1),
  //     }));
  //   }
  // };
  const handlePrevStep = () => {
    if (state.currentStep === 2) {
      confirmBackToObjectiveModalRef.current.openModal();
    } else if (state.currentStep === 3) {
      // Add or update `type=back` in the current URL
      const searchParams = new URLSearchParams(location.search);
      searchParams.set("type", "back");

      navigate(`${location.pathname}?${searchParams.toString()}`, {
        replace: true,
      });

      setState((prev) => ({
        ...prev,
        currentStep: prev.currentStep - 1,
      }));
    } else if (state.currentStep === 4) {
      confirmBackToStepLocationModalRef.current.openModal();
    } else if (state.currentStep === 5) {
      const searchParams = new URLSearchParams(location.search);
      searchParams.set("type", "back");

      navigate(`${location.pathname}?${searchParams.toString()}`, {
        replace: true,
      });

      setIsBackNavigation(true); // Set back navigation flag

      setState((prev) => ({
        ...prev,
        currentStep: prev.currentStep - 1,
      }));
    } else {
      setState((prev) => ({
        ...prev,
        currentStep: Math.max(prev.currentStep - 1, 1),
      }));
    }
  };
  const handleTabChange = (tab) => {
    setState((prev) => ({ ...prev, currentTab: tab }));
  };
  const handleConfirmBackToStepLocation = () => {
    const searchParams = new URLSearchParams(location.search);
    searchParams.set("type", "back");

    navigate(`${location.pathname}?${searchParams.toString()}`, {
      replace: true,
    });

    setIsBackNavigation(true); // Set back navigation flag

    setState((prev) => ({
      ...prev,
      currentStep: prev.currentStep - 1,
    }));
    confirmBackToStepLocationModalRef.current.closeModal();
  };
  const handleConfirmNotGenInfo = () => {
    const searchParams = new URLSearchParams(location.search);
    searchParams.set("type", "");

    navigate(`${location.pathname}?${searchParams.toString()}`, {
      replace: false,
    });
    setIsBackNavigation(false);
    setState((prev) => ({
      ...prev,
      currentStep: prev.currentStep - 1,
    }));
    confirmBackToStepLocationModalRef.current.closeModal();
  };
  const renderStepContent = () => {
    switch (state.currentStep) {
      case 1:
        return (
          <StepObjectives
            currentStep={state.currentStep}
            isModalOpen={state.modalOpenQualificationQuestions}
            onObjectiveSelect={handleObjectiveSelect}
            selectedObjectiveName={state.selectedObjective?.name}
            key={state.resetObjectivesKey}
          />
        );
      case 2:
        return (
          <StepWhatsAsk
            currentTab={state.currentTab}
            onTabChange={handleTabChange}
            selectedObjectiveId={state.selectedObjective?.id}
            selectedObjectiveName={state.selectedObjective?.name}
            selectedObjectiveStatus={state.selectedObjectiveStatus?.status}
          />
        );
      case 3:
        return <DemographicSearch />;
      case 4:
        return (
          <StepLocation
            isBackNavigation={isBackNavigation}
            setIsBackNavigation={setIsBackNavigation}
            objectiveName={objectiveNameRedux}
            currentStep={state.currentStep}
            shopperCount={shopperCount}
            setShopperCount={setShopperCount}
            totalCost={totalCost}
            questType={questType}
            setQuestType={setQuestType}
          />
        );
      case 5:
        return (
          <StepPreview
            questName={questName ? questName : objectiveNameRedux}
            tokenXP={tokenXP}
            shopperCount={shopperCount}
          />
        );
      default:
        return null;
    }
  };
  return (
    <>
      <LoadingCommon
        statusLoading={
          // isLoadingObjectiveData ||
          isLoadingCalculatorTokenXP || isLoadingCreateQuest
        }
      />
      <div className="flex flex-col justify-center items-center mx-auto w-full max-w-[480px] bg-gray-100 min-h-screen relative">
        <div className="fixed top-0 left-0 w-full z-50 flex justify-center items-center">
          <Header
            subTitle={
              state.currentStep === 5
                ? t("quest.onDemand.questPreview")
                : t("quest.onDemand.questDesign")
            }
            subTitleIcon={
              !isDropDownOpen ? images.MenuIconWhite : images.CloseIconWhite
            }
            // onMenuClick={() => setIsDropDownOpen(!isDropDownOpen)}
            isDropDownOpen={isDropDownOpen}
            // onSubTitleClick={handleOptionOndemand}
            onSubTitleClick={() => setIsDropDownOpen(!isDropDownOpen)}
            className={"justify-end max-w-[480px]"}
            textDiscard={"Discard"}
            onDropDownDiscardClick={handleOptionOndemand}
            textContinue={"Continue"}
            onDropDownCotinueClick={() => setIsDropDownOpen(false)}
          />
        </div>
        <div className="h-16"></div>
        <div className="flex-1 overflow-y-auto pb-28 w-full px-4">
          <h1 className="p-4 text-2xl font-bold">
            {state.currentStep === 1
              ? t("quest.onDemand.whatDoWeWantToKnow")
              : state.currentStep === 3
              ? t("quest.onDemand.whoWeShouldAsk")
              : state.currentStep === 4
              ? t("quest.title")
              : state.currentStep === 5
              ? ""
              : t("quest.onDemand.whatDoWeWantToAsk")}
          </h1>
          {renderStepContent()}
        </div>
        <div className="fixed bottom-0 left-0 w-full bg-white p-3 z-40">
          <div className="flex flex-col items-center gap-2 justify-center mx-auto max-w-[480px]">
            {state.currentStep <= 4 && (
              <div className="flex gap-1 items-center self-center py-2">
                {Array.from({ length: displayedTotalSteps - 1 }, (_, index) => (
                  <div
                    key={index}
                    className={`flex shrink-0 self-stretch my-auto rounded-xl h-[5px] ${
                      state.currentStep === index + 1
                        ? "bg-indigo-600"
                        : "bg-stone-200"
                    }`}
                    style={{
                      width: index + 1 === state.currentStep ? "24px" : "14px",
                    }}
                  />
                ))}
              </div>
            )}
            <div
              className={`flex w-full gap-4 ${
                state.currentStep === 1 ? "justify-center" : "justify-evenly"
              }`}
            >
              {state.currentStep !== 1 && (
                <button
                  onClick={handlePrevStep}
                  disabled={state.currentStep === 1}
                  className="flex-1 flex items-center justify-center px-4 py-2 text-sm bg-white rounded-full border border-stone-200 max-w-[240px] opacity-100"
                >
                  <img
                    src={images.PrevIcon}
                    alt="Prev"
                    className="w-5 h-5 mr-1"
                  />
                  <span>
                    {state.currentStep === 5
                      ? t("base.back")
                      : t("base.previous")}
                  </span>
                </button>
              )}
              <button
                onClick={handleNextStep}
                className="flex-1 flex items-center justify-center px-4 py-3 text-sm text-white bg-[#3F54DF] rounded-full max-w-[240px] opacity-100"
              >
                <span>
                  {state.currentStep === 5 ? t("base.lauch") : t("base.next")}
                </span>
                <img
                  src={images.NextWhiteIcon}
                  alt="Next"
                  className="w-5 h-5 ml-1"
                />
              </button>
            </div>
          </div>
        </div>
      </div>

      <CommonModal
        ref={optionOndemandModalRef}
        className="w-[380px]"
        actions={(closeModal) => (
          <>
            <Button
              text={t("quest.onDemand.discard")}
              className="flex-1 shrink gap-2.5 self-stretch px-5 py-3 rounded-xl min-h-[40px] bg-white border border-solid border-stone-200 text-neutral-500"
              onClick={handleDiscard}
            />
            <Button
              text={t("base.cancel")}
              className="flex-1 shrink gap-2.5 self-stretch px-5 py-3 rounded-xl min-h-[40px] text-white bg-indigo-600"
              variant="primary"
              onClick={() => {
                closeModal(false);
                setIsDropDownOpen(false);
              }}
            />
          </>
        )}
      >
        <div className="flex flex-col justify-between gap-2">
          <h2 className="cursor-pointer">
            {t("quest.onDemand.discardConfirm")}
          </h2>
        </div>
      </CommonModal>

      <CommonModal
        ref={confirmBackToObjectiveModalRef}
        actions={(closeModal) => (
          <>
            <Button
              text={t("base.cancel")}
              className="flex-1 shrink gap-2.5 self-stretch px-5 py-3 rounded-xl min-h-[40px] text-white bg-indigo-600"
              onClick={() => closeModal(false)}
            />
            <Button
              text={t("base.confirm")}
              className="flex-1 shrink gap-2.5 self-stretch px-5 py-3 rounded-xl min-h-[40px] bg-white border border-solid border-stone-200 text-neutral-500"
              variant="primary"
              onClick={handleConfirmBackToObjective}
            />
          </>
        )}
      >
        <div className="flex flex-col justify-between gap-2">
          <p className="text-sm">
            {t("quest.onDemand.areYouSureYouWantToGoBackToTheObjective")}
          </p>
          <p className="text-sm">
            {t("quest.onDemand.youWillLoseAllTheProgressYouHaveMade")}
          </p>
        </div>
      </CommonModal>

      <CommonModal
        ref={confirmBackToStepLocationModalRef}
        actions={(closeModal) => (
          <>
            <Button
              text={t("base.no")}
              variant="primary"
              className="flex-1 shrink gap-2.5 self-stretch px-5 py-3 rounded-xl min-h-[40px]   bg-white border border-solid border-stone-200 text-neutral-500"
              // onClick={handleConfirmBackToStepLocation}
              onClick={handleConfirmNotGenInfo}
            />
            <Button
              text={t("base.confirm")}
              // onClick={handleConfirmNotGenInfo}
              onClick={handleConfirmBackToStepLocation}
              className="flex-1 shrink gap-2.5 self-stretch px-5 py-3 rounded-xl min-h-[40px] text-white bg-indigo-600"
            />
          </>
        )}
      >
        <div className="flex flex-col justify-between gap-2">
          <p className="text-sm">
            {t("quest.onDemand.returnToTheSegmentationPage")}
          </p>
          <p className="text-sm">
            {t("quest.onDemand.saveInformationOnQuestInfo")}
          </p>
        </div>
      </CommonModal>
    </>
  );
};

export default QuestOndemand;
